import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
// @mui icons
import Icon from "@mui/material/Icon";
import Staffs from "layouts/staffs";
import Users from "layouts/users";
import Mobile from "layouts/mobile";
import Roles from "layouts/role";
import Plans from "layouts/plans";
import ProtectedRoute from "components/ProtectedRoute";
import UserDashboard from "layouts/user-dashboard";
import Reviews from "layouts/reviews";
import AbstractCategories from "layouts/abstractcategories";
import Abstracts from "layouts/abstracts";
import Judges from "layouts/judges";
import Groups from "layouts/groups";
import MyAbstracts from "layouts/myabstracts";
import Posters from "layouts/posters";
import MyPosters from "layouts/myposters";
import AccompanyingPersons from "layouts/accompanyingpersons";
import SpeakerPaper from "layouts/speakerabstracts";
import Speakers from "layouts/speakers";
import Exhibitors from "layouts/exhibitors";
import Organisers from "layouts/organisers";
import EventInfo from "layouts/eventInfo";
import Downloads from "layouts/downloads";
import Quick from "layouts/quick";
import Reports from "layouts/report";
import Days from "layouts/days";
import Quiz from "layouts/quiz";
import AbstractDoc from "layouts/abstractdoc";
import Scanner from "layouts/scanner";
import Attendence from "layouts/attendence";
import Results from "./layouts/results";
import HotelBookings from "./layouts/hotelbookings";


const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Scientific Chairman",
    key: "Scientific-Chairman",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/Scientific-Chairman",
    component: (
      <ProtectedRoute>
        <Staffs />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Judges",
    key: "judges",
    icon: <Icon fontSize="small">gavel</Icon>,
    route: "/judges",
    component: (
      <ProtectedRoute>
        <Judges />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Groups",
    key: "groups",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/groups",
    component: (
      <ProtectedRoute>
        <Groups />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Assigned Paper",
    key: "assigned-paper",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/assigned-paper",
    component: (
      <ProtectedRoute>
        <MyAbstracts />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Assigned Poster",
    key: "assigned-poster",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/assigned-poster",
    component: (
      <ProtectedRoute>
        <MyPosters />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: (
      <ProtectedRoute>
        <Users />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Speakers",
    key: "speakers",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/speakers",
    component: (
      <ProtectedRoute>
        <Speakers />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Accompanying Persons",
    key: "accompanying-persons",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/accompanying-persons",
    component: (
      <ProtectedRoute>
        <AccompanyingPersons />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Payment History",
    key: "payment",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/history",
    component: (
      <ProtectedRoute>
        <Reviews />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categories",
    component: (
      <ProtectedRoute>
        <Plans />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Paper Categories",
    key: "paper-categories",
    icon: <Icon fontSize="small">layers</Icon>,
    route: "/paper-categories",
    component: (
      <ProtectedRoute>
        <AbstractCategories />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Paper",
    key: "paper",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/paper",
    component: (
      <ProtectedRoute>
        <Abstracts />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Speaker Abstract",
    key: "speaker-abstract",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/speaker-abstract",
    component: (
      <ProtectedRoute>
        <SpeakerPaper />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Poster",
    key: "poster",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/poster",
    component: (
      <ProtectedRoute>
        <Posters />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Roles",
    key: "roles",
    icon: <Icon fontSize="small">verified_user</Icon>,
    route: "/roles",
    component: (
      <ProtectedRoute>
        <Roles />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Staffs",
    key: "staffs",
    icon: <Icon fontSize="small">people_alt</Icon>,
    route: "/staffs",
    component: (
      <ProtectedRoute>
        <Staffs />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Mobile Users",
    key: "mobile-users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/mobile-users",
    component: (
      <ProtectedRoute>
        <Mobile />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Exhibitors",
    key: "exhibitors",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/exhibitors",
    component: (
      <ProtectedRoute>
        <Exhibitors />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Committee",
    key: "committee",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/committee",
    component: (
      <ProtectedRoute>
        <Organisers />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    icon: <Icon fontSize="small">people_alt</Icon>,
    route: "/events",
    component: (
      <ProtectedRoute>
        <EventInfo />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/reports",
    component: (
      <ProtectedRoute>
        <Reports />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Downloads",
    key: "downloads",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/downloads",
    component: (
      <ProtectedRoute>
        <Downloads />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Quick",
    key: "quick",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/quick",
    component: (
      <ProtectedRoute>
        <Quick />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Days",
    key: "days",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/days",
    component: (
      <ProtectedRoute>
        <Days />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Quiz",
    key: "quiz",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/quiz",
    component: (
      <ProtectedRoute>
        <Quiz />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Quiz Results",
    key: "quiz-results",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/quiz-results",
    component: (
      <ProtectedRoute>
        <Results />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Abstract Doc",
    key: "abstract-doc",
    icon: <Icon fontSize="small">file_download</Icon>,
    route: "/abstract-doc",
    component: (
      <ProtectedRoute>
        <AbstractDoc />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/profile",
    component: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },

  {
    type: "collapse",
    name: "Scanner",
    key: "scanner",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/scanner",
    component: (
      <ProtectedRoute>
        <Scanner />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Attendence",
    key: "attendence",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/attendence",
    component: (
      <ProtectedRoute>
        <Attendence />
      </ProtectedRoute>
    ),
  },
  {
    type: "route",
    hide: true,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    hide: true,
    route: "/user-dashboard/:userId",
    component: <UserDashboard />,

  },
  {
    type: "collapse",
    name: "Bookings",
    key: "bookings",
    icon: <Icon fontSize="small">hotel</Icon>,
    route: "/bookings",
    component: (
      <ProtectedRoute>
        <HotelBookings />
      </ProtectedRoute>
    ),
  },
];


const iconMap = {
  "Dashboard": "dashboard",
  "Scientific Chairman": "admin_panel_settings",
  "Judges": "gavel",
  "Groups": "group_work",
  "Assigned Paper": "assignment_turned_in",
  "Assigned Poster": "assignment",
  "Users": "group",
  "Speakers": "record_voice_over",
  "Accompanying Persons": "person_add",
  "Payment History": "payments",
  "Categories": "category",
  "Paper Categories": "layers",
  "Paper": "description",
  "Speaker Abstract": "speaker_notes",
  "Poster": "image",
  "Roles": "shield",
  "Staffs": "supervisor_account",
  "Mobile Users": "smartphone",
  "Exhibitors": "storefront",
  "Committee": "diversity_3",
  "Events": "event",
  "Reports": "bar_chart",
  "Downloads": "cloud_download",
  "Quick": "flash_on",
  "Days": "calendar_today",
  "Quiz": "quiz",
  "Abstract Doc": "article",
  "Profile": "account_circle",
  'Scanner': 'qr_code_scanner'
};


routes.forEach(route => {
  if (route.type === "collapse" && iconMap[route.name]) {
    route.icon = <Icon fontSize="small">{iconMap[route.name]}</Icon>;
  }
});

export default routes;
